module.exports = __webpack_public_path__ + "img/ch14_12_萤火虫之夜.afb74109.jpg";